import { ENDPOINT } from '../globals/endpoint';
import { apiHelper } from '../helpers/api-helper';

interface EsignResponse {
  status: string;
  esignUrl: string;
}

export const getEsignUrl = async (): Promise<EsignResponse> => {
  const url = ENDPOINT.Sign;

  const response = await apiHelper(url, {
    method: 'POST',
    body: '',
  });

  const res = await response.json();

  return response.ok ? res : void 0;
};
